import { useEffect } from "react";
import { db } from "./offlineDB";
import axios from "axios";

function SyncManager() {
  useEffect(() => {
    async function syncRequests() {
      const items = await db.pendingRequests.toArray();

      for (const req of items) {
        try {
          await axios({
            url: req.url,
            method: req.method,
            data: req.body,
            headers: {
              Authorization: `Bearer ${req.token}`,
            },
          });

          await db.pendingRequests.delete(req.id);
        } catch (err) {
          console.log("Sync failed, will retry later");
        }
      }
    }

    window.addEventListener("online", syncRequests);
    return () => window.removeEventListener("online", syncRequests);
  }, []);

  return null;
}

export default SyncManager;
